"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleRadiusMode = void 0;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const double_click_zoom_1 = __importDefault(require("@mapbox/mapbox-gl-draw/src/lib/double_click_zoom"));
const Constants = __importStar(require("@mapbox/mapbox-gl-draw/src/constants"));
const length_1 = __importDefault(require("@turf/length"));
const common_selectors_1 = require("@mapbox/mapbox-gl-draw/src/lib/common_selectors");
const create_vertex_1 = __importDefault(require("@mapbox/mapbox-gl-draw/src/lib/create_vertex"));
exports.CircleRadiusMode = {}; //Object.assign({}, DrawLineString);
exports.CircleRadiusMode.onSetup = function () {
    const circleState = {
        circle: this.newFeature({
            type: Constants.geojsonTypes.FEATURE,
            properties: {},
            geometry: {
                type: Constants.geojsonTypes.POLYGON,
                coordinates: [],
            },
        }),
    };
    this.addFeature(circleState.circle);
    this.clearSelectedFeatures();
    double_click_zoom_1.default.disable(this);
    this.updateUIClasses({ mouse: "add" });
    this.setActionableState({
        trash: true,
    });
    return circleState;
};
exports.CircleRadiusMode.clickAnywhere = function (state, e) {
    // this ends the drawing after the user creates a second point, triggering this.onStop
    if (state.point) {
        return this.changeMode("simple_select", { featureIds: [state.circle.id] });
    }
    this.updateUIClasses({ mouse: "add" });
    state.point = this.newFeature((0, create_vertex_1.default)(state.circle.id, [e.lngLat.lng, e.lngLat.lat], 0, true));
    state.circle.properties["meta:pointCoordinates"] = state.point.coordinates;
};
exports.CircleRadiusMode.clickOnVertex = function (state) {
    this.deleteFeature(state.circle.id);
    return this.changeMode(Constants.modes.SIMPLE_SELECT, {});
};
exports.CircleRadiusMode.onMouseMove = function (state, e) {
    if (state.point) {
        if (!state.line) {
            state.line = this.newFeature({
                type: "Feature",
                geometry: {
                    type: "LineString",
                    coordinates: [state.point.getCoordinates()],
                },
                properties: {
                    parent: state.circle.id,
                    active: "true",
                },
            });
        }
        state.line.updateCoordinate(1, e.lngLat.lng, e.lngLat.lat);
        const center = state.point.coordinates;
        const radiusInKm = (0, length_1.default)(state.line.toGeoJSON(), {
            units: "kilometers",
        });
        const coordinates = getCircleCoordinates(center, radiusInKm);
        state.circle.setCoordinates(coordinates);
    }
};
exports.CircleRadiusMode.onTap = exports.CircleRadiusMode.onClick = function (state, e) {
    if ((0, common_selectors_1.isVertex)(e))
        return this.clickOnVertex(state, e);
    this.clickAnywhere(state, e);
};
exports.CircleRadiusMode.onStop = function (state) {
    double_click_zoom_1.default.enable(this);
    this.activateUIButton();
    // check to see if we've deleted this feature
    if (this.getFeature(state.circle.id) === undefined)
        return;
    if (state.circle.isValid()) {
        this.map.fire(Constants.events.CREATE, {
            features: [state.circle.toGeoJSON()],
        });
    }
    else {
        this.deleteFeature([state.circle.id], { silent: true });
        this.changeMode("simple_select", {}, { silent: true });
    }
};
exports.CircleRadiusMode.onTrash = function (state) {
    this.deleteFeature([state.circle.id], { silent: true });
    this.changeMode(Constants.modes.SIMPLE_SELECT);
};
exports.CircleRadiusMode.toDisplayFeatures = function (state, geojson, display) {
    const isActive = geojson.properties.id === state.circle.id;
    geojson.properties.active = isActive
        ? Constants.activeStates.ACTIVE
        : Constants.activeStates.INACTIVE;
    if (!state.point)
        return;
    const pointGeojson = state.point.toGeoJSON();
    pointGeojson.properties.active = isActive;
    display(pointGeojson);
    const lineGeoJson = state.line.toGeoJSON();
    display(lineGeoJson);
    display(geojson);
};
//create a circle-like polygon given a center point and radius
//https://stackoverflow.com/questions/37599561/drawing-a-circle-with-the-radius-in-miles-meters-with-mapbox-gl-js/39006388#39006388
function getCircleCoordinates(center, radiusInKm, points = 64) {
    const coords = {
        latitude: center[1],
        longitude: center[0],
    };
    const km = radiusInKm;
    const ret = [];
    const distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
    const distanceY = km / 110.574;
    let theta;
    let x;
    let y;
    for (let i = 0; i < points; i += 1) {
        theta = (i / points) * (2 * Math.PI);
        x = distanceX * Math.cos(theta);
        y = distanceY * Math.sin(theta);
        ret.push([coords.longitude + x, coords.latitude + y]);
    }
    ret.push(ret[0]);
    return [ret];
}
